import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  Paper
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import StorageIcon from '@mui/icons-material/Storage';

const AgentDetailsDialog = ({ open, onClose, agent }) => {
  if (!agent) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <InfoIcon color="primary" />
          <Typography variant="h6">Detalles del Agente</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {/* Información General */}
        <Paper elevation={0} sx={{ p: 2, mb: 2, bgcolor: 'grey.50' }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Información General
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2">
              <strong>Nombre:</strong> {agent.agentName || 'N/A'}
            </Typography>
            <Typography variant="body2">
              <strong>ID:</strong> {agent.agentId || 'N/A'}
            </Typography>
            <Typography variant="body2">
              <strong>Workspace:</strong> {agent.semanticWorkspaceId || 'N/A'}
            </Typography>
            <Typography variant="body2">
              <strong>Modelo fundacional:</strong> {agent.foundationModel || 'N/A'}
            </Typography>
            <Typography variant="body2">
              <strong>Estado:</strong>{' '}
              <Chip
                label={agent.agentStatus || 'UNKNOWN'}
                size="small"
                color={agent.agentStatus === 'ACTIVE' ? 'success' : 'default'}
              />
            </Typography>
          </Box>
        </Paper>

        {/* Instrucción */}
        {agent.instruction && (
          <Paper elevation={0} sx={{ p: 2, mb: 2, bgcolor: 'grey.50' }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Instrucción (system prompt)
            </Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              {agent.instruction}
            </Typography>
          </Paper>
        )}

        {/* Tools / conexiones */}
        <Paper elevation={0} sx={{ p: 2, mb: 2, bgcolor: 'grey.50' }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Tools habilitadas
          </Typography>
          {agent.enabledTools && agent.enabledTools.length > 0 ? (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
              {agent.enabledTools.map((tool) => (
                <Chip
                  key={tool}
                  size="small"
                  label={
                    agent.connectionIds && agent.connectionIds[tool]
                      ? `${tool}: ${agent.connectionIds[tool]}`
                      : tool
                  }
                />
              ))}
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Este agente no tiene tools habilitadas.
            </Typography>
          )}
        </Paper>

        {/* Knowledge Base */}
        {agent.knowledgeBases && agent.knowledgeBases.length > 0 ? (
          <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50' }}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <StorageIcon color="primary" />
              <Typography variant="subtitle2" color="text.secondary">
                Base de Conocimiento
              </Typography>
            </Box>
            {agent.knowledgeBases.map((kb) => (
              <Typography variant="body2" key={kb.knowledgeBaseId}>
                <strong>Nombre:</strong> {kb.name || kb.knowledgeBaseId}
              </Typography>
            ))}
          </Paper>
        ) : (
          <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.50' }}>
            <Typography variant="body2" color="text.secondary">
              No hay base de conocimiento asociada a este agente.
            </Typography>
          </Paper>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgentDetailsDialog;
